import {ValueDefinition} from '@/model/types';

export enum PeriodicDepositStatus {
  Active = 'DV-100#0',
  Held = 'DV-100#1',
}

export const DV_100 = {
  id: 'DV-100',
  description: {
    fr: 'Statut des dépôts périodiques',
    en: 'Periodic deposits status',
  },
  values: [
    {
      id: '0',
      value: {
        fr: 'Enregistré',
        en: 'Scheduled',
      },
    },
    {
      id: '1',
      value: {
        fr: 'Suspendu',
        en: 'On hold',
      },
    },
  ],
} as const satisfies ValueDefinition;
